import { render, staticRenderFns } from "./viewImage.vue?vue&type=template&id=2b8e1836&scoped=true"
import script from "./viewImage.vue?vue&type=script&lang=js"
export * from "./viewImage.vue?vue&type=script&lang=js"
import style0 from "./viewImage.vue?vue&type=style&index=0&id=2b8e1836&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8e1836",
  null
  
)

export default component.exports